module.exports = __webpack_public_path__ + "static/hvik_logo-c8e649c7e7f0ec7740cf2535ab421afe.png";